import React, { useEffect, useState } from "react";
import Loader from "components/Loader/Loader";
import Modal from "components/common/Modal/Modal";
import Banner from "components/Banner/banner";
import { formatCurrency } from "ultils/currency-formatter";
import { TenantRentService } from "services/tenant-rent-payment";
import ExpenseDetails from "pages/Expenses/ExpenseDetails";

const FinanceDashboard: React.FC = () => {
  const [finances, setFinances] = useState<any>();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTile, setSelectedTile] = useState<{} | any>({});

  const [inputValue, setInputValue] = useState<string>(""); // State to track the input value
  const [isDeleteEnabled, setIsDeleteEnabled] = useState<boolean>(false); // State to enable/disable delete button

  //   const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const loadProperties = async () => {
    try {
      const data = await TenantRentService.FetchFinanceDataForCurrentMonth();
      console.log(data);
      setFinances(data);

      setFinances(data);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadProperties();
  }, []);

  //   const tileClicked = (selectedTile: any) => {
  //     setSelectedTile(selectedTile);
  //     openModal();
  //   };

  const closeModalBtn = () => {
    setSelectedTile({});
    setInputValue("");
    setIsDeleteEnabled(false);
    closeModal();
  };

  // Handle the input change
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
    // Enable the delete button if the input matches the selected street address
    if (e.target.value === selectedTile.streetAddress) {
      setIsDeleteEnabled(true);
    } else {
      setIsDeleteEnabled(false);
    }
  };

  const deleteProperty = async () => {
    try {
      //   await PropertyService.deleteProperty(selectedTile.propertyId);
      // Reload properties after successful deletion
      await loadProperties();
      closeModalBtn();
      alert("Property deleted successfully");
    } catch (error) {
      console.error("Error deleting property:", error);
      alert("Failed to delete property. Please try again.");
    }
  };
  const expenseUpdate = () => {
    console.log("hi");
  };
  return (
    <div className="bg">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h1 className="dashboard-header">Finance Dashboard</h1>
      </div>
      {/* <p>
        <b>{ogProperties.length} </b> properties
        <br />
        <b>{totalUnits}</b> total units
      </p> */}
      {error ? <div>Error: {error}</div> : ""}
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div
            style={{
              display: "flex",
              gap: "2rem",
            }}
          >
            <div
              className="tile"
              style={{
                textAlign: "center",
                padding: ".5rem",
                background: "#9162c015",
                width: "100%",
              }}
            >
              <div className="header-container">
                <span
                  style={{
                    backgroundColor: true ? "#6f42c1" : "#17A2B8",
                    color: "#fff",
                  }}
                  className="status-badge"
                >
                  A+
                </span>
              </div>
              <h2
                style={{
                  color: "#9162c0",
                  textDecoration: "none",
                  fontSize: "2rem",
                }}
              >
                {formatCurrency(finances.grossCashFlow)}
              </h2>
              <p>
                <b>gross cashflow this month</b>
              </p>
            </div>
            <div
              className="tile"
              style={{
                padding: ".5rem",
                background: "#3b88e925",
                textAlign: "center",
                width: "100%",
              }}
            >
              <div className="header-container">
                <span
                  style={{
                    backgroundColor: "#3b88e9",
                    color: "#fff",
                  }}
                  className="status-badge"
                >
                  A+
                </span>
              </div>
              <h2
                style={{
                  color: "#3b88e9",
                  textDecoration: "none",
                  fontSize: "2rem",
                }}
              >
                {formatCurrency(finances.netCashFlowBeforeExpenses)}
              </h2>
              <p>
                <b>Gross Rent Kept</b>
              </p>
            </div>
          </div>
          <div
            style={{
              marginTop: "2rem",
              display: "flex",
              gap: "2rem",
            }}
          >
            <div
              className="tile"
              style={{
                textAlign: "center",
                padding: ".5rem",
                background: "#d1772415",
                width: "100%",
              }}
            >
              <div className="header-container">
                <span
                  style={{
                    backgroundColor: "#d17724",
                    color: "#fff",
                  }}
                  className="status-badge"
                >
                  A+
                </span>
              </div>
              <h2
                style={{
                  color: "#d17724",
                  textDecoration: "none",
                  fontSize: "2rem",
                }}
              >
                {formatCurrency(finances.totalMonthlyMortgages)}
              </h2>
              <p>
                <b>Recurring Mortgages</b>
              </p>
            </div>
            <div
              className="tile"
              style={{
                textAlign: "center",
                padding: ".5rem",
                background: "#d1772415",
                width: "100%",
              }}
            >
              <div className="header-container">
                <span
                  style={{
                    backgroundColor: "#d17724",
                    color: "#fff",
                  }}
                  className="status-badge"
                >
                  A+
                </span>
              </div>
              <h2
                style={{
                  color: "#d17724",
                  textDecoration: "none",
                  fontSize: "2rem",
                }}
              >
                {formatCurrency(finances.nonMortgageExpensesCurrentMonth)}
              </h2>
              <p>
                <b>
                  Recurring expenses for this month <br />( non mortgages )
                </b>
              </p>
            </div>
            <div
              className="tile"
              style={{
                textAlign: "center",
                padding: ".5rem",
                background: "#d1772415",
                width: "100%",
              }}
            >
              <div className="header-container">
                <span
                  style={{
                    backgroundColor: "#d17724",
                    color: "#fff",
                  }}
                  className="status-badge"
                >
                  A+
                </span>
              </div>
              <h2
                style={{
                  color: "#d17724",
                  textDecoration: "none",
                  fontSize: "2rem",
                }}
              >
                {formatCurrency(
                  finances.currentYearTotalExpensesWithoutMortgages
                )}
              </h2>
              <p>
                <b>
                  total expenses this year <br />( non mortgages )
                </b>
              </p>
            </div>
          </div>

          <div
            style={{
              marginTop: "2rem",
              display: "flex",
              gap: "2rem",
            }}
          >
            <div
              className="tile"
              style={{
                padding: ".5rem",
                background: "#449d5d15",
                textAlign: "center",
                width: "100%",
              }}
            >
              <div className="header-container">
                <span
                  style={{
                    backgroundColor: "#449d5d",
                    color: "#fff",
                  }}
                  className="status-badge"
                >
                  A+
                </span>
              </div>
              <h2
                style={{
                  color: "#449d5d",
                  textDecoration: "none",
                  fontSize: "2rem",
                }}
              >
                {formatCurrency(finances.netOperatingCashFlow)}
              </h2>
              <p>
                <b>net cashflow kept this month</b>
              </p>
            </div>
          </div>
          <div style={{ marginTop: "24px" }}>
            <ExpenseDetails
              propertyDetails={""}
              expenseList={finances.allExpenses}
              onExpenseUpdate={expenseUpdate}
            />
          </div>
        </div>
      )}

      <Modal
        title={"Delete Property?"}
        isOpen={isModalOpen}
        onClose={closeModal}
      >
        <div>
          <Banner
            type="warning"
            header={"Are you sure you want to delete this property?"}
            body={
              "Deleting this property will remove it from being updated, and you will no longer see it on your dashboard. Any units attached to this property will be unaccessible. Tenants will still be accessible and editable. Financial data will also be kept to present you with financial data of your portoflio"
            }
          />

          <p>Please enter the street address to confirm deletion:</p>
          <input
            type="text"
            value={inputValue}
            onChange={handleInputChange}
            placeholder="Enter street address"
          />
          <p>
            <b>{selectedTile.streetAddress}</b> - this is case sensitive. Please
            write it exactly as it is displayed.
          </p>
          <div className="header-container">
            <button
              className="btn"
              onClick={closeModalBtn}
              style={{ backgroundColor: "gray", color: "white" }}
            >
              Cancel
            </button>
            <button
              className="btn"
              onClick={deleteProperty}
              disabled={!isDeleteEnabled}
              style={{ backgroundColor: "red", color: "white" }}
            >
              Delete
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default FinanceDashboard;
